<script>

    import {EventBus} from '../lib/EventBus';

    export default {


        render () {
            return [];
          },

        mounted () {

            document.addEventListener('keydown', function(e){
                 // console.log('key', e.keyCode);

                 e.preventDefault();

                let is_player = !!document.getElementById("player");


                 switch (e.keyCode) {

                    case 8: // back
                        window.history.back();
                    break;


                    case 37: // left
                        if (is_player) {
                            EventBus.$emit('rewind');
                        } else {
                            nextfocus(0, -1);
                        }
                    break;


                    case 38: // up
                        nextfocus(-1, 0);
                    break;


                    case 39: // right
                        if (is_player) {
                            EventBus.$emit('fwd');
                        } else {
                            nextfocus(0, 1);
                        }
                    break;


                    case 40: // down
                        nextfocus(1, 0);
                    break;

                    case 13: // enter
                        if (is_player) {
                            EventBus.$emit('play-pause');
                        } else {
                           document.getElementById(window.currentfocus).click();
                        }
                    break;

                    case 49: // 1
                    case 415: // play
                        EventBus.$emit('play');
                    break;

                    case 50: // 2
                    case 19: // pause
                        EventBus.$emit('pause');
                    break;

                    case 51: // 3
                    case 463: // play/pause
                        EventBus.$emit('play-pause');
                    break;

                    case 52: // 4
                    case 413: // stop
                        if (is_player) {
                            EventBus.$emit('stop');
                        } else {
                            window.close();
                        }
                    break;

                    case 53: // 5
                    case 417: // Fast FWD
                        EventBus.$emit('fwd');
                    break;

                    case 54: // 6
                    case 412: // Rewind
                        EventBus.$emit('rewind');
                    break;

                 }

            });

            window.nextfocus = function (l, p) {

                // console.log('nextfocus', l ,p);

                var focus = window.currentfocus.split('_');
                var level = parseInt(focus[1]);
                var pos = parseInt(focus[2]);

                if (level === 3 && l === 1) {
                    var currentWidth = window.innerWidth
                    if (currentWidth < 480) {
                        l = 0;
                        p = 1;
                    } else if (currentWidth < 800) {
                        l = 0;
                        p = 2;
                    } else if (currentWidth < 1200) {
                        l = 0;
                        p = 3;
                    } else {
                        l = 0;
                        p = 4;
                    }
                }
                if (level === 3 && l === -1) {

                        var currentWidth = window.innerWidth;
                        if (currentWidth < 480 && pos >= 1) {
                            l = 0;
                            p = -1;
                        } else if (currentWidth < 800 && pos >= 2) {
                            l = 0;
                            p = -2;
                        } else if (currentWidth < 1200 && pos >= 3) {
                            l = 0;
                            p = -3;
                        } else if (pos >= 4) {
                            l = 0;
                            p = -4;
                        }
                    }

                var nextLevel = level + l;
                var nextPos = pos + p;
                if (nextLevel !== level) {
                    nextPos = 0;
                }

                var focus = 'i_' + nextLevel + '_' + nextPos;
                // console.log('current Focus: ', window.currentfocus);
                // console.log('next Focus: ', focus);
                var elem = document.getElementById(focus);
                if (elem) {
                    setNextFocus(focus);
                    return true;
                } else if (nextLevel === 2 && level === 1) {
                    return nextfocus(2, 0);
                } else if (nextLevel === 2 && level === 3) {
                    return nextfocus(-2, 0);
                }

                return false;
            };

            window.setNextFocus = function(id) {
                var lastFocus = document.getElementsByClassName('current-focus');
                Array.prototype.forEach.call(lastFocus, function(el) {
                    el.classList.remove('current-focus');
                });
                var nextElement = document.getElementById(id);
                nextElement.classList.add('current-focus');

                if (id === 'i_1_0') {
                    window.scrollToTop();
                } else {
            //        nextElement.scrollIntoView({block: "start", behavior: "smooth"});
                    nextElement.scrollIntoViewIfNeeded(true);
                }

                window.currentfocus = id;
            };


        }
    }

</script>


// WEBPACK FOOTER //
// KeyEvents.vue?1276bc62